module.exports = __webpack_public_path__ + "img/sort／pad／Fighting@2x.bb3c6586.png";